export const gitInfo = 'v0.1 (develop #73f414d - 04112024-0954) jorgegonza***';
